import sdl from '@jds/react-generated-sdl/JDSToggle';
import type { JDSToggleProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, InputToggleProps } from '../logic';

const Component = (props: InputToggleProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    checked = false,
    labelPosition = 'left',
    size = 'medium',
    disabled = false,
    ariaLabel = props.label?.toString(),
    _ariaChecked = props.checked?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      checked,
      labelPosition,
      size,
      disabled,
      ariaLabel,
      _ariaChecked,
      ...rest
    },
    'JDSToggle',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const InputToggle = withLogic(Component) as React.FC<InputToggleProps> & {
  slotName?: string;
};

InputToggle.displayName = 'InputToggle';
InputToggle.slotName = 'jds_toggle';

export { InputToggle, type JDSToggleProps };
